import { Button } from 'components/button/Button';
import { InputField } from 'components/input/InputField';
import { Formik } from 'components/form/formik';
import toast from 'react-hot-toast';
import { useSWRConfig } from 'swr';
import * as Yup from 'yup';

import { createVatRate, VAT_RATES_SWR_KEY } from '../models';
import { getDisplayError } from '../../../utils/get-display-error';
import { parseNumberInput } from '../../../utils/number';
import { captureException } from '@sentry/react';

const createVatRateSchema = Yup.object().shape({
  id: Yup.string().required('Vereist'),
  amount: Yup.string().required('Vereist'),
  description: Yup.string().required('Vereist'),
});

interface IVatRateValues {
  id: string;
  amount: string;
  description: string;
}

const initialValues: IVatRateValues = {
  id: '',
  amount: '0.00',
  description: '',
};

interface ICreateVatRateFormProps {
  onComplete?: (value: { id: string; amount: number; description: string }) => void;
  onCancel?: () => void;
}

export const CreateVatRateForm: React.FC<ICreateVatRateFormProps> = (props) => {
  const { onComplete, onCancel } = props;
  const { mutate } = useSWRConfig();

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={createVatRateSchema}
      onSubmit={async (values) => {
        try {
          await createVatRate({
            ...values,
            amount: parseNumberInput(values.amount, 2),
          });
          await mutate(VAT_RATES_SWR_KEY);
          onComplete?.({
            ...values,
            amount: parseNumberInput(values.amount, 2),
          });
          toast.success('btw type aangemaakt');
        } catch (err: any) {
          captureException(err);
          toast.error('Kon btw type niet aanmaken: ' + getDisplayError(err));
        }
      }}
    >
      {({ handleSubmit, isSubmitting, errors, submitForm }) => {
        return (
          <form onSubmit={handleSubmit}>
            <InputField labelText="Code" type="text" name="id" />
            <InputField labelText="Percentage" type="text" name="amount" />
            <InputField labelText="Beschrijving" type="text" name="description" />

            <div className="flex justify-between">
              {onCancel && (
                <div>
                  <Button isDisabled={isSubmitting} isLoading={isSubmitting} onTrigger={onCancel}>
                    Annuleer
                  </Button>
                </div>
              )}
              <Button
                type="submit"
                color="primary"
                isDisabled={isSubmitting}
                isLoading={isSubmitting}
                onTrigger={submitForm}
              >
                Maak btw type aan
              </Button>
            </div>
          </form>
        );
      }}
    </Formik>
  );
};
